import { create } from 'zustand';
import { FrameworkAgreement } from '@/types';

// The two facets the sidebar actually offers. A third, `legalEntities`, sat here with
// no control setting it and nothing reading it — an always-0 term in the badge (LR-661).
interface CounterpartyFilters {
  statuses: string[];
  agreementTypes: FrameworkAgreement[];
}

interface CounterpartyFilterState {
  searchQuery: string;
  filters: CounterpartyFilters;
  setSearchQuery: (query: string) => void;
  setFilters: (filters: CounterpartyFilters) => void;
  resetFilters: () => void;
}

export const useCounterpartyFilterStore = create<CounterpartyFilterState>((set) => ({
  searchQuery: '',
  filters: {
    statuses: [],
    agreementTypes: [],
  },
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  resetFilters: () =>
    set({
      filters: {
        statuses: [],
        agreementTypes: [],
      },
    }),
}));
